export const controlsSize = 10;
export const controlsStroke = 1;

const gray = 80;
export const controlsColor = `rgba(${gray}, ${gray}, ${gray}, 0.8)`;
export const controlsContrastColor = '#FFF';
